module.exports = __webpack_public_path__ + "static/media/1000L.59c21dd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/1000L.mp3
// module id = tPRS
// module chunks = 1